import { Injectable, OnInit } from '@angular/core';
import { update } from '@angular/fire/database';
import { Database, get, getDatabase, orderByValue, push, query, ref } from 'firebase/database';
import CONFIG from 'src/app/app.config';
import { FirebaseService } from 'src/app/d3/services/firebase.service'

@Injectable({
  providedIn: 'root'
})
export class PathService implements OnInit {    
  private pathMaps: any[] = [];
  private promise?: Promise<Object>;
  private version : String = CONFIG.RELEASE.VERSION;
  private db: Database;
  
  constructor(private fbService : FirebaseService) {
    console.log("Initializing path service with services");
    this.db = getDatabase(); 
  }

  ngOnInit() {
  }

  getList(section?: String) {
    var dbName = section;
    var itemsRef = ref(this.db, `${this.version}/${dbName}`); //this.fbService.db(`${this.version}/${dbName}`);
    
    this.promise = new Promise(function(resolve, reject) {  
        const orderByQuery = query(itemsRef, orderByValue());
        get(orderByQuery).then((snapshot: any) => {
    //   itemsRef.orderByValue().on('value', (snapshot: any) => {
        let items = snapshot.val();
        if(! items) {
          reject("Failed to obtain values from service")
        }

        resolve(items)
      })
    })

    return this.promise;
  }

  getPathMaps() {
    console.log("THIS GETPATHMAPS: ", this.pathMaps)
    return this.pathMaps;
  }


  /**
   * //TODO: create a list of sections where updates are allowed
   * @param section 
   * @param data 
   * @returns 
   */
  update(section: String, data: any) : Promise<any> {
    let parsedData = JSON.parse(JSON.stringify(data));
    let dbRef = ref(this.db, `${this.version}/${section}`); //this.fbService.db(`${this.version}/${section}`);
    return update(dbRef, parsedData);
  }

  /**
   * This addes a new data and returns the key
   * @param section 
   * @param data 
   * @returns 
   */
  push(section: String, data: any) : String{
    let parsedData = JSON.parse(JSON.stringify(data));
    let dbRef = ref(this.db, `${this.version}/${section}`);//this.fbService.db(`${this.version}/${section}`);
    // return dbRef.push(parsedData)?.key;
    return push(dbRef, parsedData)?.key as String;
  }
}
